import userflow from 'userflow.js';
import { config } from 'common/config';
import { User } from 'types';


export const initUserflow = (user: User) => {
  if (config.userflowToken) {
    userflow.init(config.userflowToken);
    userflow.identify(`${user.id}`, {
      name: user.fullName,
      email: user.emailAddress,
      signed_up_at: user.createdAt,
    });
  }
};
